import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['audio', 'button', 'playIcon', 'pauseIcon', 'progress', 'currentTime', 'duration']

  connect () {
    this._onLoadedMetadata = () => { this.updateDuration() }
    this._onTimeUpdate = () => { this.updateProgress() }
    this._onEnded = () => { this.resetPlaybackState() }

    if (this.hasAudioTarget) {
      this.audioTarget.addEventListener('loadedmetadata', this._onLoadedMetadata)
      this.audioTarget.addEventListener('timeupdate', this._onTimeUpdate)
      this.audioTarget.addEventListener('ended', this._onEnded)
    }
  }

  disconnect () {
    if (!this.hasAudioTarget) return

    this.audioTarget.removeEventListener('loadedmetadata', this._onLoadedMetadata)
    this.audioTarget.removeEventListener('timeupdate', this._onTimeUpdate)
    this.audioTarget.removeEventListener('ended', this._onEnded)
  }

  toggle (event) {
    event.preventDefault()
    if (!this.hasAudioTarget) return

    if (this.audioTarget.paused) {
      this.audioTarget.play()
      this.setPlaying(true)
    } else {
      this.audioTarget.pause()
      this.setPlaying(false)
    }
  }

  seek (event) {
    if (!this.hasAudioTarget || !this.hasProgressTarget) return

    const percent = Number(event.target.value)
    if (!Number.isFinite(percent) || !Number.isFinite(this.audioTarget.duration) || this.audioTarget.duration <= 0) return

    this.audioTarget.currentTime = (percent / 100) * this.audioTarget.duration
    this.updateProgress()
  }

  updateDuration () {
    if (!this.hasDurationTarget) return
    this.durationTarget.textContent = this.formatTime(this.audioTarget.duration)
  }

  updateProgress () {
    if (this.hasProgressTarget && Number.isFinite(this.audioTarget.duration) && this.audioTarget.duration > 0) {
      this.progressTarget.value = ((this.audioTarget.currentTime || 0) / this.audioTarget.duration) * 100
    }

    if (this.hasCurrentTimeTarget) {
      this.currentTimeTarget.textContent = this.formatTime(this.audioTarget.currentTime)
    }
  }

  resetPlaybackState () {
    this.setPlaying(false)
    if (this.hasProgressTarget) this.progressTarget.value = 0
    if (this.hasCurrentTimeTarget) this.currentTimeTarget.textContent = '0:00'
  }

  setPlaying (playing) {
    if (this.hasPlayIconTarget) this.playIconTarget.classList.toggle('hidden', playing)
    if (this.hasPauseIconTarget) this.pauseIconTarget.classList.toggle('hidden', !playing)
  }

  formatTime (seconds) {
    const safe = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0
    const mins = Math.floor(safe / 60)
    const secs = safe % 60
    return `${mins}:${String(secs).padStart(2, '0')}`
  }
}
